import flatpickr from "flatpickr";
import { Dutch } from "flatpickr/dist/l10n/nl.js"

document.addEventListener("initializeDistributionDatePicker", (data) => {
    const element = document.getElementById('agenda-distribution__date');
    let unavailableDates = [];

    if(data.detail.unAvailableDates) {
        unavailableDates = JSON.parse(data.detail.unAvailableDates);
    }

    flatpickr(element, {
        dateFormat: "d-m-Y",
        allowInput: true,
        disable: [
            ...unavailableDates,
            function(date) {
                // return true to disable weekends
                return (date.getDay() === 1 || date.getDay() === 6 || date.getDay() === 7 || date.getDay() === 0 || date.getDay() === 5);
            },
            function(date) {
                // Disable past dates
                const today = new Date();
                return (date < today);
            }
        ],
        locale: Dutch,
    });
});
